import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight } from 'lucide-react';

const blogPosts = [
  {
    slug: 'best-ai-humanizers-2026',
    title: 'Best AI Humanizers in 2026: Complete Comparison',
    excerpt: 'We tested 12 AI humanizers to find which ones actually work against Turnitin and GPTZero. Penocio came out on top with 97% bypass rate.',
    category: 'Reviews',
    date: '2026-01-15',
    author: 'Sarah Chen'
  },
  {
    slug: 'how-turnitin-detects-ai',
    title: 'How Turnitin Detects AI Writing (And How to Beat It)',
    excerpt: 'Deep dive into Turnitin AI detection algorithm, its accuracy, and proven strategies to humanize your AI text.',
    category: 'Education',
    date: '2026-01-14',
    author: 'Dr. James Mitchell'
  },
  {
    slug: 'gptzero-vs-originality-ai',
    title: 'GPTZero vs Originality AI: Which Detector is More Accurate?',
    excerpt: 'Head-to-head comparison of the two leading AI detection tools. Test results with 1,000 samples.',
    category: 'Comparisons',
    date: '2026-01-12',
    author: 'Sarah Chen'
  },
  {
    slug: 'how-ai-detection-works',
    title: 'How AI Detection Tools Actually Work',
    excerpt: 'Understanding the technology behind Turnitin, GPTZero, and other AI detectors. Machine learning models explained.',
    category: 'Education',
    date: '2026-01-10',
    author: 'Michael Roberts'
  },
  {
    slug: 'is-using-ai-cheating',
    title: 'Is Using AI for Essays Cheating? The Ethics Debate',
    excerpt: 'A balanced look at academic integrity, AI assistance tools, and where to draw the line.',
    category: 'Education',
    date: '2026-01-08',
    author: 'Dr. James Mitchell'
  },
  {
    slug: 'penocio-vs-lunchbreak',
    title: 'Penocio vs Lunchbreak AI: Which is Better?',
    excerpt: 'Side-by-side comparison of features, pricing, and effectiveness. Real test results included.',
    category: 'Comparisons',
    date: '2026-01-05',
    author: 'Emma Wilson'
  },
  {
    slug: 'humanize-chatgpt-text',
    title: 'How to Humanize ChatGPT Text: 7 Proven Methods',
    excerpt: 'Step-by-step guide to making ChatGPT output sound more natural and pass AI detection.',
    category: 'Guides',
    date: '2026-01-03',
    author: 'Sarah Chen'
  },
  {
    slug: 'ai-detection-bypass-legal',
    title: 'AI Detection Bypass: Is It Legal? What Students Need to Know',
    excerpt: 'Legal implications, academic policies, and ethical considerations of using AI humanization tools.',
    category: 'Education',
    date: '2025-12-28',
    author: 'Dr. James Mitchell'
  },
  {
    slug: 'best-paraphrasing-tools-students',
    title: 'Top 10 Paraphrasing Tools for Students in 2026',
    excerpt: 'Comprehensive review of paraphrasing tools: QuillBot, Penocio, Wordtune, and more.',
    category: 'Reviews',
    date: '2025-12-25',
    author: 'Emma Wilson'
  },
  {
    slug: 'write-like-human-not-ai',
    title: 'How to Write Like a Human (Not AI): Complete Guide',
    excerpt: 'Techniques to naturally incorporate AI assistance while maintaining your unique voice.',
    category: 'Guides',
    date: '2025-12-20',
    author: 'Michael Roberts'
  },
  {
    slug: 'future-ai-detection',
    title: 'The Future of AI Writing Detection: 2026 and Beyond',
    excerpt: 'Predictions from AI experts on how detection technology will evolve and what it means for writers.',
    category: 'Analysis',
    date: '2025-12-15',
    author: 'Dr. James Mitchell'
  },
  {
    slug: 'can-teachers-detect-chatgpt',
    title: 'Can Teachers Really Detect ChatGPT Writing?',
    excerpt: 'Survey of 500 educators reveals surprising accuracy rates and common misconceptions.',
    category: 'Education',
    date: '2025-12-10',
    author: 'Sarah Chen'
  }
];

const Blog = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <div className="flex-1 py-24">
        <div className="container mx-auto max-w-5xl">
          <div className="text-center mb-16">
            <Badge className="mb-4" variant="secondary">Blog</Badge>
            <h1 className="text-4xl md:text-6xl font-heading font-black tracking-tighter mb-6">
              Latest Insights
            </h1>
            <p className="text-lg text-muted-foreground">
              Tips, guides, and news about AI writing and detection.
            </p>
          </div>

          <div className="space-y-8">
            {blogPosts.map((post) => (
              <Card key={post.slug} className="p-8 border-zinc-200 hover:shadow-lg transition">
                <div className="flex items-start justify-between mb-4">
                  <Badge variant="outline">{post.category}</Badge>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Calendar className="h-4 w-4" />
                      {post.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <User className="h-4 w-4" />
                      {post.author}
                    </span>
                  </div>
                </div>
                <h2 className="text-2xl font-heading font-bold mb-3">{post.title}</h2>
                <p className="text-muted-foreground mb-4">{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`}>
                  <Button variant="outline">
                    Read More
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </Card>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blog;
